










































import Vue from 'vue'
import { Auth } from 'aws-amplify'
import { extendSessionByThreeHours } from '../../contexts/transcription/src/store/modules/sessionExtender'

export default Vue.extend({
  data() {
    return {
      showModal: false,
      isAuth: true,
      diff: 0,
      timeLimit: 90 * 60 * 1000,
      worker: null as Worker | null
    }
  },
  methods: {
    handleActivity() {
      if (this.diff <= 5 * 60 * 1000) {
        this.handleExtendTime()
      }
      if (this.showModal) {
        this.showModal = false
      }
    },
    handleVisibilityChange() {
      if (document.hidden) {
        this.handleCancel()
      } else {
        // Document is visible again, check if session has expired
        const lastActivity = localStorage.getItem('lastActivity')
        if (
          lastActivity &&
          new Date().getTime() - new Date(lastActivity).getTime() >
            this.timeLimit
        ) {
          this.handleCancel()
        } else {
          this.startTimer()
        }
      }
    },
    startTimer() {
      if (this.isAuth && navigator.onLine) {
        const et = localStorage.getItem('et')
        localStorage.setItem('lastActivity', new Date().toString())
        this.worker.postMessage({ type: 'start', et })
      }
    },
    handleWorkerMessage(event: any) {
      const timeRemaining = event.data
      this.diff = timeRemaining
    },

    handleCancel() {
      this.showModal = false
      if (this.worker) {
        this.worker.postMessage({ type: 'stop' })
      }
      Auth.signOut({ global: true })
        .then(() => this.$store.commit('setClientId', undefined))
        .then(() => localStorage.clear())
    },
    async handleExtendTime() {
      const cognitoUser = await Auth.currentAuthenticatedUser()
      const refreshToken = cognitoUser.getSignInUserSession().getRefreshToken()

      cognitoUser.refreshSession(refreshToken, (err, _session) => {
        if (err) {
          console.error(err)
        } else {
          extendSessionByThreeHours(true)
          localStorage.setItem('lastActivity', new Date().toString())
          this.worker.postMessage({
            type: 'start',
            et: localStorage.getItem('et')
          })
          if (this.showModal) {
            this.showModal = false
          }
        }
      })
    },
    handleNetworkChange() {
      if (navigator.onLine) {
        // When the network goes online, check if the last activity was more than 30 minutes ago
        const lastActivity = localStorage.getItem('lastActivity')
        if (
          lastActivity &&
          new Date().getTime() - new Date(lastActivity).getTime() >
            this.timeLimit
        ) {
          this.handleCancel() // If it was, log out
        }
      }
    }
  },
  watch: {
    diff(newValue) {
      if (newValue <= 0) {
        this.isAuth = false
        this.showModal = false
        if (this.worker) {
          this.worker.postMessage({ type: 'stop' })
        }
        this.handleCancel()
      } else if (newValue <= 60000 && !this.showModal) {
        this.showModal = true
      }
    }
  },
  mounted() {
    this.worker = new Worker('/timerWorker.js')
    this.worker.addEventListener('message', this.handleWorkerMessage)

    // If there is a 'lastActivity' value and it was more than 30 minutes ago, log out
    const lastActivity = localStorage.getItem('lastActivity')
    // Listen for when the network goes from offline to online
    window.addEventListener('online', this.handleNetworkChange)
    if (
      lastActivity &&
      new Date().getTime() - new Date(lastActivity).getTime() > this.timeLimit
    ) {
      this.handleCancel()
    } else {
      this.startTimer()
    }
    window.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        // Document is visible again, check if session has expired
        const lastActivity = localStorage.getItem('lastActivity')
        if (
          lastActivity &&
          new Date().getTime() - new Date(lastActivity).getTime() >
            this.timeLimit
        ) {
          this.handleCancel()
        } else {
          this.startTimer()
        }
      }
    })
    window.addEventListener('click', this.handleActivity)
    window.addEventListener('keyup', this.handleActivity)
  },

  beforeDestroy() {
    if (this.worker) {
      this.worker.postMessage({ type: 'stop' })
      this.worker.removeEventListener('message', this.handleWorkerMessage)
      this.worker.terminate()
    }

    window.removeEventListener('online', this.handleNetworkChange)
    window.removeEventListener('visibilitychange', this.handleVisibilityChange)
    window.removeEventListener('click', this.handleActivity)
    window.removeEventListener('keyup', this.handleActivity)
  }
})
